import React from "react";
import { HiOutlineBars3, HiOutlineXMark } from "react-icons/hi2";
import { getNavIcon } from "./NavIcons";
import { HeaderActions } from "./HeaderActions";
import { btnHover, roundedBtn } from "./designTokens";

export function Header({
  isMobileMenuOpen,
  setIsMobileMenuOpen,
  navItems,
  isActive,
  user,
  handleLogout,
  t,
}) {
  const currentItem = navItems.find((item) => isActive(item.path));

  return (
    <header className="sticky top-0 z-40 border-b border-slate-200/50 dark:border-slate-600/50 bg-white/10 dark:bg-gray-800/50 backdrop-blur-lg shadow-xl">
      <div className="px-4 sm:px-6 py-3 ">
        <div className="flex items-center justify-between gap-2">
          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className={`lg:hidden p-2.5 ${roundedBtn} ${btnHover} transition-colors text-white`}
            aria-label={isMobileMenuOpen ? "Fermer le menu" : "Ouvrir le menu"}
            aria-expanded={isMobileMenuOpen}
            aria-controls="mobile-menu"
          >
            {isMobileMenuOpen ? (
              <HiOutlineXMark className="w-6 h-6" />
            ) : (
              <HiOutlineBars3 className="w-6 h-6" />
            )}
          </button>

          <div className="flex-1 flex items-center gap-2 text-sm min-w-0 text-white">
            <span className="shrink-0 w-5 h-5 text-white">
              {getNavIcon(currentItem?.icon || "dashboard")}
            </span>
            <span className="text-white/80">/</span>
            <span className="font-semibold truncate text-white">
              {currentItem?.label || t("home") || "Accueil"}
            </span>
          </div>

          <HeaderActions user={user} handleLogout={handleLogout} t={t} />
        </div>
      </div>
    </header>
  );
}
